export default "__VITE_ASSET__DdyRG6rm__"